module.exports = __webpack_public_path__ + "img/body-1-lg.0aa3be88.png";